import Button from "@mui/material/Button";
import React from "react";
import RegFlow from "../regFlow/regFlow";
import RegFlowVersionB from "../regFlowVersionB/regFlow";
import { getOrPickVariant } from "../utils/abVariant";
import { canAccessFlowVersionB } from "../utils/flowVersionBAccess";

export default function RegFlowABEntry() {
  // Real 5%-of-visitors A/B roll (sticky cookie) — regFlowVersionB is now live for real traffic.
  const variant = React.useMemo(() => getOrPickVariant("regflow"), []);

  const [useVersionB, setUseVersionB] = React.useState(false);
  const canSwitchToVersionB = canAccessFlowVersionB();
  const shouldShowVersionB = variant === "B" || useVersionB;

  return (
    <>
      {canSwitchToVersionB && !shouldShowVersionB && (
        <Button
          variant="outlined"
          size="small"
          onClick={() => setUseVersionB(true)}
          sx={{ mb: 2 }}
        >
          Open RegFlow B
        </Button>
      )}
      {shouldShowVersionB ? <RegFlowVersionB /> : <RegFlow />}
    </>
  );
}
